import { SessionDataType } from "./types";

export function sessionTick(payload: string) {
  return {
    type: SessionDataType.SESSION_TICK,
    payload,
  };
}

// use isOpenAccountLookup argument to pull sessions while opening lookup session from the Accounts tab
export function pullListSessions(isOpenAccountLookup?: boolean) {
  return {
    type: SessionDataType.PULL_SESSIONS,
    payload: { isOpenAccountLookup },
  };
}

export function setSessionsList(payload: any) {
  return {
    type: SessionDataType.SET_SESSIONS,
    payload,
  };
}
export function setSelectedSession(payload: any) {
  return {
    type: SessionDataType.SET_SESSION_BY_ID,
    payload,
  };
}
export function getSessionDetailById(payload: string) {
  return {
    type: SessionDataType.GET_SESSION_BY_ID,
    payload,
  };
}

export function getSessionAccounts(payload: string) {
  return {
    type: SessionDataType.GET_ACCOUNTS,
    payload,
  };
}

export function setSessionAccounts(payload: string) {
  return {
    type: SessionDataType.SET_ACCOUNTS,
    payload,
  };
}

export function setSessionNotification(
  type: string,
  message: string,
  icon: string,
  randomId: number
) {
  return {
    type: SessionDataType.SET_SESSION_NOTIFICATION,
    payload: { type, message, icon, randomId },
  };
}

export function clearSessionNotification() {
  return {
    type: SessionDataType.CLEAR_SESSION_NOTIFICATION,
  };
}

export function clearSelectedSession() {
  return {
    type: SessionDataType.CLEAR_SELECTED_SESSION,
  };
}

export function removeSessionById(id: string) {
  return {
    type: SessionDataType.REMOVE_SESSION,
    payload: id,
  };
}

export function setAccountViewed(accountName: string) {
  return {
    type: SessionDataType.SET_ACCOUNT_VIEWED,
    payload: accountName,
  };
}
